import { ISelectOption } from './selectOption.interface';
import { FilterTypesEnum } from '../filters/filterTypes.enum';
import { ResourceType } from '../api/common';
import { beautifyCamelCaseString } from 'src/app/common/stringUtils';

export const ConnectionConnectorTypeSelectOptions: ISelectOption[] = [
  {
    id: `${FilterTypesEnum.ConnectionConnectorType}-${ResourceType.connector}`,
    value: ResourceType.connector,
    displayName: beautifyCamelCaseString(ResourceType.connector),
    categoryName: FilterTypesEnum.ConnectionConnectorType.toString(),
    filterType: FilterTypesEnum.ConnectionConnectorType,
    withoutBeautifyDisplayName: true,
  },
  {
    id: `${FilterTypesEnum.ConnectionConnectorType}-${ResourceType.custom_connector}`,
    value: ResourceType.custom_connector,
    displayName: beautifyCamelCaseString(ResourceType.custom_connector),
    categoryName: FilterTypesEnum.ConnectionConnectorType.toString(),
    filterType: FilterTypesEnum.ConnectionConnectorType,
    withoutBeautifyDisplayName: true,
  },
];
